
//Import asset file(s) used by this module.
import '../../assets/skins/MainAssets.js';
import '../../assets/skins/SplashAssets.js';
import '../../assets/skins/DialogScenes.js';

/////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////

import AppInstaller from '../../../shared/src/ranj/app/core/AppInstaller.js';
import GameClock from '../../../shared/lib/html5-software-library/src/ranj/eng/story/framework/clock/GameClock.js';
import AbstractInstaller from '../../../shared/src/ranj/app/core/AbstractInstaller.js';
import AppModel from '../../../shared/src/ranj/app/core/AppModel.js';
import ContextEvent from "../../../shared/src/ranj/app/core/ContextEvent";
import GameEvent from '../../../shared/src/ranj/app/core/GameEvent.js';
import SkinKeys from '../../../shared/src/ranj/app/ui/SkinKeys.js';
import StartGameCommand from './collaboration/core/controller/StartGameCommand.js';
import InitCollaborationGameTask from './collaboration/core/controller/InitCollaborationGameTask.js';
import GameConfig from './collaboration/core/model/GameConfig.js';
import GameModel from './collaboration/core/model/GameModel.js';
import NGTAssetLocator from './collaboration/ngt/base/NGTAssetLocator.js';
import NGTVariableManager from './collaboration/ngt/base/NGTVariableManager.js';
import PlayDialogCommand from './collaboration/ngt/dialog/controller/PlayDialogCommand.js';
import DialogFactory from './collaboration/ngt/dialog/DialogFactory.js';
import CollaborationDialogPlayer from './collaboration/ngt/dialog/CollaborationDialogPlayer.js';
import DialogScreenMediator from './collaboration/ngt/dialog/view/DialogScreenMediator.js';
import InitPlaySessionTask from './collaboration/ngt/playsession/InitPlaySessionTask.js';
import PlaySessionModel from './collaboration/ngt/playsession/PlaySessionModel.js';
import InitializeScenariosCommand from './collaboration/ngt/scenario/controller/InitializeScenariosCommand.js';
import PlayScenarioCommand from './collaboration/ngt/scenario/controller/PlayScenarioCommand.js';
import ScenarioCommandEvent from './collaboration/ngt/scenario/controller/ScenarioCommandEvent.js';
import NGTScenarioPlayer from './collaboration/ngt/scenario/NGTScenarioPlayer.js';
import NGTStoryFactory from './collaboration/ngt/scenario/NGTStoryFactory.js';
import ScenarioLibrary from './collaboration/ngt/scenario/ScenarioLibrary.js';
import ScenarioPlayerEvent from './collaboration/ngt/scenario/ScenarioPlayerEvent.js';
import EndScreenMediator from './collaboration/end/EndScreenMediator.js';
import SplashLoadScreenMediator from './collaboration/splash/SplashLoadScreenMediator.js';
import TransitionScreenMediator from './collaboration/transition/TransitionScreenMediator.js';
import ShowSplashScreenTask from '../../../shared/src/ranj/equalture/startup/ShowSplashScreenTask.js';
import LoadStartupAssetsTask from '../../../shared/src/ranj/app/startup/LoadStartupAssetsTask.js';
import InitLanguageTask from '../../../shared/src/ranj/equalture/startup/InitLanguageTask.js';
import SaveModel from './collaboration/core/model/SaveModel.js';
import SaveEvent from '../../../shared/src/ranj/equalture/savegame/SaveEvent.js';
import SaveCommand from '../../../shared/src/ranj/equalture/savegame/SaveCommand.js';
import GameCompletedCommand from './collaboration/core/controller/GameCompletedCommand.js';
import TrackingController from './collaboration/tracking/controller/TrackingController.js';
import GameFlowEvent from './collaboration/core/controller/GameFlowEvent.js';
import StartScenarioCommand from './collaboration/core/controller/StartScenarioCommand.js';
import InterruptGameCommand from '../../../shared/src/ranj/app/core/InterruptGameCommand.js';
import EpisodeSelectionScreenMediator from './collaboration/episode-selection/EpisodeSelectionScreenMediator.js';
import MultipleSelectionOptionsMediator from './collaboration/ngt/dialog/view/interactions/MultipleSelectionOptionsMediator.js';
import IntrospectionOptionsMediator from './collaboration/ngt/dialog/view/interactions/IntrospectionOptionsMediator.js';
import SingleSelectionOptionsMediator from './collaboration/ngt/dialog/view/interactions/SingleSelectionOptionsMediator.js';
import CollaborationInitPlatformAPIServiceTask from './collaboration/platform/CollaborationInitPlatformAPIServiceTask.js';
import FinishScenarioCommand from './collaboration/ngt/scenario/controller/FinishScenarioCommand.js';
import CastInfoPanelMediator from './collaboration/info-panel/CastInfoPanelMediator.js';
import StoryInfoPanelMediator from './collaboration/info-panel/StoryInfoPanelMediator.js';
import TutorialScreenMediator from './collaboration/tutorial/TutorialScreenMediator.js';
import CollaborationExitGameCommand from './collaboration/end/CollaborationExitGameCommand.js';
import InfoPanelButtonMediator from './collaboration/info-panel/InfoPanelButtonMediator.js';


export default class MinigameInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "SplashAssets");
        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "sounds", "common", "MainAssets", "DialogScenes");


        commands.add(ContextEvent.START_GAME, StartGameCommand);
        commands.add(GameEvent.EXIT, CollaborationExitGameCommand);
        commands.add(GameEvent.COMPLETED, GameCompletedCommand);
        commands.add(GameEvent.INTERRUPT_GAME, InterruptGameCommand);

        injector.mapClass("appModel", AppModel, true);
        injector.mapClass("gameModel", GameModel, true);
        injector.mapClass("gameConfig", GameConfig, true);
        injector.mapValue("gameAssets", lib.MainAssets);
        injector.mapValue("dialogSceneAssets", lib.DialogScenes);
        injector.mapClass("trackingController", TrackingController, true);

        injector.mapClass("saveModel", SaveModel, true);
        commands.add(SaveEvent.SAVE, SaveCommand);
        commands.add(SaveEvent.CLEAR, SaveCommand);
        commands.add(GameFlowEvent.TUTORIAL_COMPLETED, StartScenarioCommand);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "preload");
        this._addStartupTask(InitCollaborationGameTask, "initGameTask", 0);

        this._addStartupTask(CollaborationInitPlatformAPIServiceTask, "InitPlatformAPIServiceTask", 0);
        this._addStartupTask(InitLanguageTask, "InitLanguageTask", 0, ["InitPlatformAPIServiceTask"]);
        this._addStartupTask(ShowSplashScreenTask, "ShowSplashScreenTask", 0);
        this._addStartupTask(LoadStartupAssetsTask, "LoadStartupAssetsTask", 30, ["InitLanguageTask"]);


        SkinKeys.SPLASH_LOAD_SCREEN_SKIN = this._mapMediator(SplashLoadScreenMediator, lib.SplashAssets.SplashLoadScreenSkin);
        SkinKeys.TUTORIAL_SCREEN = this._mapMediator(TutorialScreenMediator, lib.MainAssets.TutorialScreenSkin);
        SkinKeys.EPISODE_SELECTION_SCREEN = this._mapMediator(EpisodeSelectionScreenMediator, lib.MainAssets.EpisodeSelectionScreenSkin);
        SkinKeys.END_SCREEN = this._mapMediator(EndScreenMediator, lib.MainAssets.EndScreenSkin);
        SkinKeys.TRANSITION_SCREEN = this._mapMediator(TransitionScreenMediator, lib.MainAssets.TransitionScreenSkin);
        SkinKeys.CAST_INFO_SKIN = this._mapMediator(CastInfoPanelMediator);
        SkinKeys.STORY_INFO_SKIN = this._mapMediator(StoryInfoPanelMediator);
        SkinKeys.INFO_BUTTON_SKIN = this._mapMediator(InfoPanelButtonMediator);

        // From NGT :
        // NGT basics
        injector.mapClass("assetLocator", NGTAssetLocator, true);

        // Scenario playing
        injector.mapClass("gameClock", GameClock, true);
        injector.mapClass("variableManager", NGTVariableManager, true);

        injector.mapClass("scenarioPlayer", NGTScenarioPlayer, true);
        injector.mapClass("scenarioLibrary", ScenarioLibrary, true);
        injector.mapClass("storyFactory", NGTStoryFactory, true);
        commands.add(ScenarioCommandEvent.INITIALIZE_SCENARIOS, InitializeScenariosCommand);
        commands.add(ScenarioCommandEvent.PLAY_SCENARIO, PlayScenarioCommand);
        commands.add(ScenarioCommandEvent.FINISH_SCENARIO, FinishScenarioCommand);
        injector.mapClass("playSessionModel", PlaySessionModel, true);

        this._addStartupTask(InitPlaySessionTask, "initPlaySession");

        // Dialog playing
        injector.mapClass("dialogFactory", DialogFactory, true);
        injector.mapClass("dialogPlayer", CollaborationDialogPlayer, false);//NB: not a singleton!
        commands.add(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, PlayDialogCommand);
        SkinKeys.DIALOG_SCREEN_SKIN = this._mapMediator(DialogScreenMediator, lib.MainAssets.DialogScreenSkin);
        SkinKeys.DIALOG_OPTIONS_SKIN = this._mapMediator(SingleSelectionOptionsMediator);
        SkinKeys.INTROSPECTION_OPTIONS_SKIN = this._mapMediator(IntrospectionOptionsMediator);
        SkinKeys.DIALOG_MULTIPLE_SELECTION_OPTIONS_SKIN = this._mapMediator(MultipleSelectionOptionsMediator);

/////////////////////
///////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////
//////////////////
    }

}
